import {
  BookmarkEditResponseType,
  BookmarkType,
  RecruitmentDetailType,
  RecruitmentFilterResponseType,
  RecruitmentFilterType,
  RecruitmentListResponseType,
} from '../types/RecruitmentTypes';
import { RepositoryUtils } from '../utils/RepositoryUtils';
import _ from 'lodash';

const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

export const fetchRecruitments = (
  keyword: string,
  filters: RecruitmentFilterType[],
  available: boolean,
  next: string,
  size: number,
  token?: string,
) => {
  return RepositoryUtils.axiosPost<RecruitmentListResponseType>(
    `${ivyApiDomain}/api/v1/jobs/_search`,
    // 'api/v1/jobs/_search',
    {
      keyword: keyword,
      filters: filters,
      available: available,
      next: next,
      size: size,
    },
    { headers: { Authorization: _.isEmpty(token) ? '' : `Bearer ${token}` } },
  );
};

export const fetchRecruitmentDetail = (id: number, token?: string) => {
  return RepositoryUtils.axiosGet<RecruitmentDetailType>(`${ivyApiDomain}/api/v1/jobs/${id}`, {
    headers: { Authorization: _.isEmpty(token) ? '' : `Bearer ${token}` },
  });
};

export const fetchRecruitmentFilters = () => {
  return RepositoryUtils.axiosGet<RecruitmentFilterResponseType[]>(
    `${ivyApiDomain}/api/v1/jobs/filters`,
  );
};

export const fetchBookmarks = (token: string) => {
  return RepositoryUtils.axiosGet<BookmarkType[]>(`${ivyApiDomain}/api/v1/jobs/bookmarks`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addBookmark = (id: number, token: string) => {
  return RepositoryUtils.axiosPost<BookmarkEditResponseType>(
    `${ivyApiDomain}/api/v1/jobs/bookmarks`,
    // `api/v1/jobs/bookmarks`,
    {
      jobId: id,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const removeBookmark = (id: number, token: string) => {
  return RepositoryUtils.axiosDelete<BookmarkEditResponseType>(
    `${ivyApiDomain}/api/v1/jobs/bookmarks?jobId=${id}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
};
